import React from "react";
import PropTypes from "prop-types";
import "../Help.css";

const StatusMessage = ({ message, messageType }) => {
  return <h4 className={messageType === "error" ? "error" : ""}>{message}</h4>;
};

StatusMessage.propTypes = {
  message: PropTypes.string,
  messageType: PropTypes.string
};

StatusMessage.defaultProps = {
  messageType: "success"
};

export default StatusMessage;



// WEBPACK FOOTER //
// ./src/components/help/StatusMessage/index.js